import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Render } from '@oforce/global-components';
import { ShowForTypes, useActiveAccount } from '../../../shared/activeAccount';
import { HideFromRolesAndTypes } from '../../../shared/activeAccount/components';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DOCUMENT_TYPE = {
  GENERAL: 'GENERAL',
  APPLICATION: 'APPLICATION',
  CERTIFICATE_OF_INSURANCE: 'CERTIFICATE_OF_INSURANCE'
};

export default function PolicyDocumentActionsDropdown({ policy, bulkLoading, bulkError }) {
  const { url } = useRouteMatch();
  const history = useHistory();

  const {
    TYPES: { CARRIER, BROKER, CLAIMS_ADJUSTER },
    ROLES: { EXPOSURE_MANAGER, OBSERVER },
    isAdmin
  } = useActiveAccount();

  const shouldShowDocumentUploadButton = policy => {
    if (policy?.archived) return false;
    else if (policy?.expirationDate !== null && new Date(policy?.expirationDate) <= new Date()) return false;
    else if (isAdmin) return true;
    else return !policy?.apiOnlyExposureUpdates;
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);

  const bulkDisabled = !!bulkError || !!bulkLoading;

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} color="info" direction="down">
      <DropdownToggle className="ml-2 btn btn-outline-info btn-sm">
        <FontAwesomeIcon icon={['far', 'cog']} /> Actions
      </DropdownToggle>
      <DropdownMenu style={{ maxWidth: '215px' }} className="mr-4">
        <ShowForTypes types={[CARRIER, BROKER]}>
          <HideFromRolesAndTypes types={[CLAIMS_ADJUSTER]} roles={[EXPOSURE_MANAGER, OBSERVER]}>
            <Render if={shouldShowDocumentUploadButton(policy)}>
              <DropdownItem onClick={() => history.push(`${url}/upload`)}>
                <FontAwesomeIcon icon={['far', 'file-upload']} className="mr-1" style={{ minWidth: '20px' }} />
                Upload Document
              </DropdownItem>
            </Render>
            <DropdownItem onClick={() => history.push(`${url}/email`)} disabled={bulkDisabled}>
              <FontAwesomeIcon icon={['fas', 'envelope']} className="mr-1" style={{ minWidth: '20px' }} />
              Bulk Email
            </DropdownItem>
            <DropdownItem onClick={() => history.push(`${url}/mappable-fields`)}>
              <FontAwesomeIcon icon={['far', 'info-circle']} className="mr-1" style={{ minWidth: '20px' }} />
              View Mappable Fields
            </DropdownItem>
          </HideFromRolesAndTypes>
        </ShowForTypes>
        <DropdownItem onClick={() => history.push(`${url}/bulk-download`)} disabled={bulkDisabled}>
          <FontAwesomeIcon icon={['far', 'arrow-to-bottom']} className="mr-1" style={{ minWidth: '20px' }} />
          Bulk Download
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
